export default {
    methods: {
        calculateThrustLength() {
            for (var k in this.gzThrustDetail) {
                if (this.gzThrustDetail.hasOwnProperty(k)) {
                    this.gzLengthOriginal = this.gzLengthOriginal + this.gzThrustDetail[k].length
                }
            }
            this.gzLengthOriginal = this.gzLengthOriginal + 1
            for (var j in this.hkFacultyDetail) {
                if (this.hkFacultyDetail.hasOwnProperty(j)) {
                    this.hkLengthOriginal = this.hkLengthOriginal + this.hkFacultyDetail[j].length
                }
            }
        },
        hkHandleCheckAllChange(val) {
            if (val) {
                this.selectALLHK()
            } else {
                this.campusDetail.hk = []
            }
            this.hkIndeterminate = false
            this.campusThrustsConnect()
        },
        gzHandleCheckAllChange(val) {
            if (val) {
                this.selectAllGZ()
            } else {
                this.campusDetail.gz = []
            }
            this.gzIndeterminate = false
            this.campusThrustsConnect()
        },
        campusDetailHandler() {
            this.selectAllGZ()
            this.selectALLHK()
        },
        selectAllGZ() {
            this.campusDetail.gz = []
            let gz = []
            for (var k in this.gzThrustDetail) {
                if (this.gzThrustDetail.hasOwnProperty(k)) {
                    for (let i = 0; i < this.gzThrustDetail[k].length; i++) {
                        if (this.currentAvailableThrust.includes(this.correctThrust(this.gzThrustDetail[k][i].name)) || this.highPrivilegeCondition()) {
                            gz.push(this.gzThrustDetail[k][i].name)
                        }
                    }
                }
            }
            if (this.currentAvailableThrust.includes(this.correctThrust("Others")) || this.highPrivilegeCondition()) {
                gz.push("Others")
            }
            this.departmentDataUpdateHandler(gz, 'gz')
        },
        selectALLHK() {
            this.campusDetail.hk = []
            let hk = []
            for (var j in this.hkFacultyDetail) {
                if (this.hkFacultyDetail.hasOwnProperty(j)) {
                    for (let i = 0; i < this.hkFacultyDetail[j].length; i++) {
                        if (this.currentAvailableThrust.includes(this.correctThrust(this.hkFacultyDetail[j][i].name)) || this.highPrivilegeCondition()) {
                            hk.push(this.hkFacultyDetail[j][i].name)
                        }
                    }
                }
            }
            this.departmentDataUpdateHandler(hk, 'hk')
        },
        campusThrustsConnect() {
            if (this.campusDetail.gz.length == 0) {
                for (let i = this.campus.length - 1; i > -1; i--) {
                    if (this.campus[i] == "gz") {
                        this.campus.splice(i, 1)
                    }
                }
            } else {
                if (!this.campus.includes('gz'))
                    this.campus.push("gz")
            }
            if (this.campusDetail.hk.length == 0) {
                for (let i = this.campus.length - 1; i > -1; i--) {
                    if (this.campus[i] == "hk") {
                        this.campus.splice(i, 1)
                    }
                }
            } else {
                if (!this.campus.includes('hk'))
                    this.campus.push("hk")
            }
        },
        gzThrustSelect() {
            if (!this.campus.includes("gz")) {
                this.campus.push("gz")
            }
            this.gzThrustSelectorFlag = true
        },
        hkThrustSelect() {
            if (!this.campus.includes("hk")) {
                this.campus.push("hk")
            }
            this.hkThrustSelectorFlag = true
        },
    },
}
